import { OrderPlanView_OrderPlanViewTourSteps } from "../../components/TourGuide/tourGuideData";
import { useEffect, useRef, useState } from "react";
import {
  LiaHornbill,
} from "react-icons/lia";
import { MdPrint } from "react-icons/md";
import { orderPlanView, salesOrderMaster } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import BatchTable from "./BatchTable";
import { formatDate } from "../../utlis/formateDate";
import Model from "../../common/Model";
import { STATUS_COLORS } from "../../utlis/constant";
import { RegistryHeader, Button as SharedButton, CalculationFooter } from "../../common/Shared";
import { TourGuide } from "../../components/TourGuide/TourGuide";
import { Info, Sparkles, ChevronDown, ChevronUp, Send } from "lucide-react";

const OrderPlanView = () => {
  const getDiePdfUrl = (row) => {
    if (!row) return "";
    const pdfUrl = row.die_Pdf || row.diePdf || row.Die_Pdf;
    if (pdfUrl) return pdfUrl;

    const dieId = row.die_Id || row.dieId || row.Die_Id;
    if (dieId) {
      return `https://hline.blob.core.windows.net/hlinefiles/Extrusion/DieMedia/Pdf/${dieId}.pdf`;
    }
    return "";
  };

  const [isOrderplanData, setIsOrderPlanData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [batchItems, setBatchItems] = useState([]);
  const [batchId, setBatchId] = useState("");
  const [viewData, setViewData] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("sales");
  const [salesPage, setSalesPage] = useState(1);
  const [salesHasMore, setSalesHasMore] = useState(true);
  const [executedData, setExecutedData] = useState([]);
  const [executedPage, setExecutedPage] = useState(1);
  const [executedHasMore, setExecutedHasMore] = useState(true);
  const pageSize = 50;
  const tableScrollRef = useRef(null);
  const isFetchingRef = useRef(false);
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [isAutoBatchOpen, setIsAutoBatchOpen] = useState(false);
  const [autoBatchLoading, setAutoBatchLoading] = useState(false);
  const [batchSuggestions, setBatchSuggestions] = useState([]);
  const [expandedSuggestionDieId, setExpandedSuggestionDieId] = useState(null);
  const [suggestionDetails, setSuggestionDetails] = useState({});
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [sendingDieId, setSendingDieId] = useState(null);

  const handleOpenAutoBatch = async () => {
    setIsAutoBatchOpen(true);
    setAutoBatchLoading(true);
    setBatchSuggestions([]);
    setExpandedSuggestionDieId(null);
    setSuggestionDetails({});
    try {
      const res = await salesOrderMaster.getBatchSuggestions();
      const items = res?.items || res?.data || res?.suggestions || (Array.isArray(res) ? res : [res]) || [];
      setBatchSuggestions(items);
    } catch (err) {
      notify("Failed to load batch suggestions", "error");
    } finally {
      setAutoBatchLoading(false);
    }
  };

  const handleToggleSuggestionExpand = async (dieId) => {
    if (expandedSuggestionDieId === dieId) {
      setExpandedSuggestionDieId(null);
      return;
    }
    setExpandedSuggestionDieId(dieId);
    if (!suggestionDetails[dieId]) {
      setDetailsLoading(true);
      try {
        const res = await salesOrderMaster.getBatchSuggestionDetails(dieId);
        const items = res?.items || res?.data || res || [];
        setSuggestionDetails((prev) => ({ ...prev, [dieId]: Array.isArray(items) ? items : [items] }));
      } catch (err) {
        notify("Failed to load batch suggestion details", "error");
      } finally {
        setDetailsLoading(false);
      }
    }
  };

  const handleSendSuggestionToProduction = async (group) => {
    const dieId = group.die_Id || group.dieId;
    setSendingDieId(dieId);
    try {
      let details = suggestionDetails[dieId];
      if (!details) {
        const res = await salesOrderMaster.getBatchSuggestionDetails(dieId);
        details = res?.items || res?.data || res || [];
        if (!Array.isArray(details)) details = [details];
      }

      let selectedIds = details.map((item) => item.id || item.order_Detail_Id || item.sales_Order_Id || item.orderId).filter(Boolean);
      if (!selectedIds.length && group.salesOrderNos) {
        selectedIds = group.salesOrderNos.split(',').map((s) => Number(s.trim())).filter((n) => !isNaN(n) && n > 0);
      }

      if (!selectedIds.length) {
        notify("No valid orders found to send to production", "error");
        return;
      }

      await salesOrderMaster.SendToProdcution(selectedIds);
      notify("Batch sent to production successfully!", "success");

      setBatchSuggestions((prev) => prev.filter((g) => (g.die_Id || g.dieId) !== dieId));
      fetchOrderplanData(1);
    } catch (err) {
      console.error("SendToProduction Error:", err);
      notify("Failed to send batch to production", "error");
    } finally {
      setSendingDieId(null);
    }
  };

  const handleTourComplete = () => {
    localStorage.setItem("aluex_plan_tour_seen", "true");
  };

  const fetchOrderplanData = async (page) => {
    try {
      setLoading(true);
      const res = await orderPlanView.getAllPlanOrders(page, pageSize);

      setIsOrderPlanData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setSalesHasMore(false);
      }
      isFetchingRef.current = false;
    } finally {
      setLoading(false);
    }
  };

  const fetchExecutedOrders = async (page) => {
    try {
      setLoading(true);
      const res = await orderPlanView.getAllExecutedOrders(page, pageSize);

      setExecutedData((prev) => {
        return page === 1 ? res.items || [] : [...prev, ...(res.items || [])];
      });

      if (!res.items || res.items.length < pageSize) {
        setExecutedHasMore(false);
      }
      isFetchingRef.current = false;
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === "sales") {
      setSalesPage(1);
      setIsOrderPlanData([]);
      setSalesHasMore(true);
    } else {
      setExecutedPage(1);
      setExecutedData([]);
      setExecutedHasMore(true);
    }
  };

  useEffect(() => {
    if (activeTab === "sales") fetchOrderplanData(salesPage);
  }, [salesPage, activeTab]);

  useEffect(() => {
    if (activeTab === "executed") fetchExecutedOrders(executedPage);
  }, [executedPage, activeTab]);

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (loading || isFetchingRef.current) return;

      const { scrollTop, clientHeight, scrollHeight } = el;

      if (scrollHeight - scrollTop <= clientHeight + 100) {
        isFetchingRef.current = true;

        if (activeTab === "sales" && salesHasMore) {
          setSalesPage((p) => p + 1);
        }

        if (activeTab === "executed" && executedHasMore) {
          setExecutedPage((p) => p + 1);
        }
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [activeTab, loading, salesHasMore, executedHasMore]);

  const handleView = async (id) => {
    setLoading(true);
    try {
      const res = await salesOrderMaster.getById(id);
      setViewData(res.data);
      setIsViewModalOpen(true);
    } catch (err) {
      notify("Failed to load order details", "error");
    }
    setLoading(false);
  };

  const handlePrint = async (order_No) => {
    try {
      setLoading(true);

      const blob = await orderPlanView.getByPrintId(order_No);
      if (!blob) {
        notify("No PDF received from server", "warning");
        return;
      }

      const file = new Blob([blob], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const printWindow = window.open(fileURL, "_blank");

      printWindow.onload = () => {
        printWindow.print();
      };

      notify("PDF opened successfully", "success");
    } catch (err) {
      console.error("Print Error:", err);
      notify("Failed to open PDF", "error");
    } finally {
      setLoading(false);
    }
  };

  const executedColumns = [
    { key: "order_No", label: "Order No" },
    { key: "batch_Id", label: "Batch Id" },
    { key: "total_Qty", label: "Qty" },
    {
      key: "order_Date",
      label: "Ord Date",
      render: (value) => formatDate(value),
    },
    {
      key: "dispatch_Date",
      label: "Dispatch Date",
      render: (value) => formatDate(value),
    },
    { key: "general_Notes", label: "Remarks" },
  ];

  const columns = [
    {
      key: "select",
      align: "center",
      disableSort: true,
      label: (
        <input
          type="checkbox"
          checked={
            isOrderplanData.length > 0 &&
            selectedIds.length ===
            isOrderplanData.filter((i) => i?.id).map((i) => i.id).length
          }
          onChange={(e) => {
            if (e.target.checked) {
              const allIds = isOrderplanData
                .filter((i) => i?.id)
                .map((i) => i.id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
          className="w-4 h-4 text-primary cursor-pointer"
        />
      ),
      render: (_value, row) =>
        row?.id ? (
          <input
            type="checkbox"
            checked={selectedIds.includes(row.id)}
            onChange={() => {
              setSelectedIds((prev) =>
                prev.includes(row.id)
                  ? prev.filter((id) => id !== row.id)
                  : [...prev, row.id],
              );
            }}
            className="w-4 h-4 text-primary cursor-pointer"
          />
        ) : null,
    },
    { key: "order_No", label: "SO NO", align: "center" },
    {
      key: "die_Status",
      label: "DIE STATUS",
      align: "center",
      render: (val) => {
        const color = STATUS_COLORS[val] || "bg-slate-100 text-slate-600";
        return (
          <span
            className={`px-3 py-1 border rounded-none text-[9px] font-black uppercase tracking-[2px] ${color}`}
          >
            {val}
          </span>
        );
      },
    },
    { key: "cust_Name", label: "CUSTOMER", align: "center" },
    {
      key: "dieNumber",
      label: "DIE NO",
      align: "center",
      render: (val, row) => {
        const pdfUrl = getDiePdfUrl(row);
        return pdfUrl ? (
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary font-black hover:underline cursor-pointer text-[12px] uppercase tracking-tighter"
          >
            {val}
          </a>
        ) : (
          <span>{val}</span>
        );
      }
    },
    { key: "currentWeight", label: "CURRENT WT", align: "center" },
    { key: "profile_Length", label: "CUT LENGTH", align: "center" },
    { key: "qty", label: "PCS", align: "center" },
    { key: "qty_Weight", label: "WT", align: "center" },
    { key: "alloy_Name", label: "ALLOY", align: "center" },
    { key: "req_Delivery", label: "REQ. DELIVERY", align: "center" },
    { key: "status", label: "DISPATCH DAYS.", align: "center" },
  ];

  const DetailItem = ({ label, value, highlight }) => (
    <div className="flex flex-col">
      <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">
        {label}
      </span>
      <span
        className={`text-sm font-semibold ${highlight ? "text-primary" : "text-slate-800"}`}
      >
        {value || "—"}
      </span>
    </div>
  );

  // Pre-calculate summary stats for the footer
  const totalLoadPcs = isOrderplanData.reduce((sum, item) => sum + (Number(item.qty) || 0), 0);
  const totalLoadWeight = isOrderplanData.reduce((sum, item) => sum + (Number(item.qty_Weight) || 0), 0);
  const selectedPcs = isOrderplanData.filter((item) => selectedIds.includes(item.id)).reduce((sum, item) => sum + (Number(item.qty) || 0), 0);
  const selectedWeight = isOrderplanData.filter((item) => selectedIds.includes(item.id)).reduce((sum, item) => sum + (Number(item.qty_Weight) || 0), 0);
  const hasSelection = selectedIds.length > 0;

  return (
    <div className="flex flex-col h-full bg-white font-plus relative">
      {loading && <Loader centered />}
      <RegistryHeader
        title="Order Planning"
      >
        <div className="flex items-center gap-2">
          <button
            onClick={() => setIsTourOpen(true)}
            className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
            title="Page Guide"
          >
            <Info size={14} />
            Guide
          </button>
          <button
            onClick={handleOpenAutoBatch}
            className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest bg-primary hover:bg-[#2c5ebc] text-white transition-colors border border-primary shrink-0 shadow-xs"
            title="Auto Batch Suggestions"
          >
            Auto Batch
          </button>

        </div>
        <div className="flex bg-gray-100 p-1 rounded-sm gap-1" data-tour="plan-tabs">
          <button
            onClick={() => handleTabChange("sales")}
            className={`px-8 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${activeTab === "sales"
              ? "bg-primary text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Sales Orders
          </button>
          <button
            onClick={() => handleTabChange("executed")}
            className={`px-8 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${activeTab === "executed"
              ? "bg-primary text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Executed Orders
          </button>
        </div>

        {activeTab === "sales" && (
          <>

            <div data-tour="plan-batch">
              <SharedButton
                disabled={selectedIds.length === 0 || isSaving}
                onClick={async () => {
                  if (selectedIds.length === 0) return;
                  setIsSaving(true);
                  try {
                    const res = await salesOrderMaster.AddToBatch({ SelectedIds: selectedIds });
                    setBatchItems(res || []);
                    setBatchId(res.batchId || "");
                    setIsModelOpen(true);
                  } catch (err) {
                    notify("Failed to add to batch", "error");
                  } finally {
                    setIsSaving(false);
                  }
                }}
                icon={LiaHornbill}
                className="whitespace-nowrap"
                loading={isSaving}
              >
                {isSaving ? "PROCESSING..." : `Add To Batch [${selectedIds.length}]`}
              </SharedButton>
            </div>
          </>
        )}
      </RegistryHeader>

      <div className="px-8 pt-0 pb-4 flex-1 overflow-hidden flex flex-col" data-tour="plan-table">
        <div
          ref={tableScrollRef}
          className="relative overflow-auto border border-gray-200 bg-white flex-1"
        >
          {activeTab === "sales" ? (
            <div className="min-w-max">
              <Table
                columns={columns}
                data={isOrderplanData}
                showActions={false}
                tableClassName="text-[12px] font-bold"
              />
            </div>
          ) : (
            <div className="min-w-max">
              <Table
                columns={executedColumns}
                data={executedData}
                onView={(row) => handleView(row.order_No)}
                tableClassName="text-[12px] font-bold"
              />
            </div>
          )}
        </div>
      </div>

      {activeTab === "sales" && (
        <CalculationFooter
          items={[
            {
              label: "TOTAL PCS",
              value: totalLoadPcs.toLocaleString(),
              suffix: "PCS"
            },
            {
              label: "TOTAL WT",
              value: totalLoadWeight.toFixed(3),
              suffix: "KG",
              color: "text-primary"
            },
            {
              label: "SELECTED PCS",
              value: selectedPcs.toLocaleString(),
              suffix: "PCS",
              color: "text-slate-800"
            },
            {
              label: "SELECTED WT",
              value: selectedWeight.toFixed(3),
              suffix: "KG",
              color: "text-primary"
            }
          ]}
        />
      )}

      {isModelOpen && (
        <BatchTable
          batchItems={batchItems}
          batchId={batchId}
          onClose={() => {
            setIsModelOpen(false);
            setIsOrderPlanData([]);
            if (salesPage === 1) fetchOrderplanData(1);
            else setSalesPage(1);
            setSalesHasMore(true);
            setSelectedIds([]);
            setBatchItems([]);
            setBatchId("");
          }}
        />
      )}

      <Model
        isOpen={isViewModalOpen}
        onClose={() => setIsViewModalOpen(false)}
        name="Executed Order Details"
        widthClass="max-w-5xl"
      >
        {viewData && (
          <div className="flex flex-col p-1 text-plus">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 bg-slate-50/50 border border-gray-200 p-5 mb-5 font-plus rounded-none">
              <DetailItem label="Order Number" value={viewData.order_No} highlight />
              <DetailItem label="Customer Name" value={viewData.customerName} />
              <DetailItem label="Order Alloy" value={viewData.aolly_Name} />
              <DetailItem label="Order Date" value={formatDate(viewData.order_Date)} />
              <DetailItem label="Delivery Days" value={`${viewData.delivery_Days} Days`} />
              <DetailItem label="Calculated Dispatch" value={formatDate(viewData.calculate_dispatch_date)} />
            </div>
            <div className="mb-6 font-plus">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-4">
                  <span className="h-5 w-1 bg-primary"></span>
                  <h3 className="text-[11px] font-black text-gray-800 uppercase tracking-[2px]">
                    Order Items
                  </h3>
                </div>
                <button
                  className="bg-primary/50 text-white px-5 py-2 text-[10px] font-black uppercase tracking-[2px] hover:bg-primary flex items-center gap-2 transition-all"
                  onClick={() => handlePrint(viewData.order_No)}
                >
                  <MdPrint size={14} /> Print Invoice
                </button>
              </div>

              <div className="overflow-hidden border border-gray-200 bg-white">
                <Table
                  columns={[
                    { key: "dieNumber", label: "Die Profile", render: (v) => <span className="font-bold uppercase">{v}</span> },
                    { key: "currentWeight", label: "Wt", align: "center", render: (v) => <span className="font-bold">{v}</span> },
                    { key: "unit_Conv_Name", label: "Unit", align: "center", render: (v) => <span className="font-bold uppercase text-[10px] tracking-widest">{v}</span> },
                    { key: "profile_Length", label: "Length", align: "center", render: (v) => <span className="font-bold">{v}</span> },
                    { key: "qty", label: "Quantity", align: "center", render: (v) => <span className="font-black text-primary">{v}</span> },
                    { key: "qty_Weight", label: "Total weight", align: "center", render: (v) => <span className="font-black">{v}</span> },
                    {
                      key: "powder_Coating_Color",
                      label: "Coating Color",
                      render: (v) => (
                        <span className="uppercase font-bold text-[10px] tracking-widest">
                          {v || "-"}
                        </span>
                      ),
                    },
                  ]}
                  data={viewData?.orderDetails || []}
                  showActions={false}
                  tableClassName="text-[12px] font-bold"
                />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-2 font-plus">
              <div className="space-y-4">
                <div className="border border-amber-100 bg-amber-50/50 p-4">
                  <h4 className="text-[10px] font-black text-amber-800 uppercase tracking-[2px] mb-2 flex items-center gap-2">
                    <span className="w-1.5 h-3 bg-amber-400 rounded-none"></span> Packing Instructions
                  </h4>
                  <p className="text-[12px] text-gray-600 font-bold italic leading-relaxed">
                    "
                    {viewData.packingInstructions ||
                      "No specific instructions provided."}
                    "
                  </p>
                </div>
                <div className="border border-gray-200 bg-white p-4">
                  <h4 className="text-[10px] font-black text-gray-400 uppercase tracking-[2px] mb-2 flex items-center gap-2">
                    <span className="w-1.5 h-3 bg-gray-300 rounded-none"></span> General Notes
                  </h4>
                  <p className="text-[12px] text-gray-600 font-bold uppercase tracking-tight">
                    {viewData.generalNotes || "-"}
                  </p>
                </div>
              </div>

              <div className="bg-slate-50 p-6 flex flex-col justify-center gap-4 border border-slate-200 text-slate-800">
                <h3 className="text-slate-400 text-[10px] font-black uppercase tracking-[3px]"> Order Summary </h3>
                <div className="flex justify-between items-baseline border-b border-slate-200 pb-3">
                  <span className="text-slate-500 text-[11px] font-black uppercase tracking-[2px]">Total Quantity</span>
                  <span className="text-[24px] font-black leading-none"> {viewData?.total_Qty} <span className="text-[11px] text-slate-400">PCS</span> </span>
                </div>
                <div className="flex justify-between items-baseline">
                  <span className="text-slate-500 text-[11px] font-black uppercase tracking-[2px]">Estimated Weight</span>
                  <span className="text-[24px] font-black leading-none text-primary"> {viewData?.total_Weight} <span className="text-[11px] text-slate-400">KG</span> </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </Model>

      <Model
        isOpen={isAutoBatchOpen}
        onClose={() => setIsAutoBatchOpen(false)}
        name="Auto Batch Suggestions"
        widthClass="max-w-5xl"
      >
        <div className="flex flex-col h-full font-plus text-slate-800 bg-slate-50/50">


          {autoBatchLoading ? (
            <div className="py-28 text-center bg-white">
              <Loader centered />
              <span className="text-xs text-slate-400 font-bold uppercase tracking-wider block mt-4">
                Analyzing order pool & generating suggestions...
              </span>
            </div>
          ) : (
            <div className="p-2 overflow-y-auto max-h-[65vh] space-y-2">              {batchSuggestions.length > 0 ? (
              batchSuggestions.map((group, idx) => {
                const dieId = group.die_Id || group.dieId || idx + 1;
                const title = group.dieNo || group.groupName || group.batchName || `Die #${dieId}`;
                const orderCount = group.salesOrderNos ? group.salesOrderNos.split(',').filter(Boolean).length : (group.orderCount || group.noOfOrders || "-");
                const totalQty = group.pcs || group.totalQty || group.qty || "-";
                const totalWeight = group.totalWt || group.totalWeight || group.weight || "-";
                const dieStatus = group.dieStatus || "AVAILABLE";
                const currentWt = group.currentWT !== undefined ? group.currentWT : (group.currentWt !== undefined ? group.currentWt : "-");

                const isExpanded = expandedSuggestionDieId === dieId;
                const detailsList = suggestionDetails[dieId];
                const isSending = sendingDieId === dieId;

                return (
                  <div key={idx} className="bg-white border border-slate-200 rounded-xl shadow-xs overflow-hidden transition-all hover:border-primary hover:shadow-md">
                    <div className="p-6 bg-slate-50/80 border-b border-slate-100 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                      <div className="flex items-center gap-4">
                        <div className="w-11 h-11 rounded-xl bg-primary/10 text-primary flex flex-col items-center justify-center font-black border border-primary/20 shrink-0">
                          <span className="text-[9px] uppercase tracking-tighter leading-none text-primary">DIE</span>
                          <span className="text-sm leading-none mt-0.5">#{dieId}</span>
                        </div>
                        <div>
                          <div className="flex items-center gap-2.5">
                            <h4 className="text-[16px] font-black text-slate-800 uppercase tracking-wider">{title}</h4>
                            <span className={`px-2 py-0.5 text-[9px] font-black rounded border uppercase tracking-wider ${dieStatus === 'AVAILABLE' ? 'bg-primary/10 text-primary border-primary/20' : 'bg-amber-50 text-amber-700 border-amber-200'}`}>
                              {dieStatus}
                            </span>
                          </div>
                          <span className="text-[11px] text-slate-500 font-bold mt-1 block">
                            Die Wt: <span className="text-slate-800 font-black">{typeof currentWt === 'number' ? currentWt.toFixed(3) : currentWt} KG</span> | Orders: <span className="text-primary font-black">{group.salesOrderNos || "-"}</span>
                          </span>
                        </div>
                      </div>

                      <div className="flex flex-wrap items-center gap-4">
                        <div className="flex items-center gap-5 bg-white px-5 py-2 rounded-lg border border-slate-200 shadow-2xs">
                          <div className="text-center">
                            <span className="text-[8px] font-black text-slate-400 uppercase tracking-widest block">ORDERS</span>
                            <span className="text-[14px] font-black text-slate-800">{orderCount}</span>
                          </div>
                          <div className="w-[1px] h-6 bg-slate-200" />
                          <div className="text-center">
                            <span className="text-[8px] font-black text-slate-400 uppercase tracking-widest block">TOTAL QTY</span>
                            <span className="text-[14px] font-black text-slate-800">{totalQty} <span className="text-[9px] text-slate-400">PCS</span></span>
                          </div>
                          <div className="w-[1px] h-6 bg-slate-200" />
                          <div className="text-center">
                            <span className="text-[8px] font-black text-slate-400 uppercase tracking-widest block">EST. WEIGHT</span>
                            <span className="text-[14px] font-black text-primary">{typeof totalWeight === 'number' ? totalWeight.toFixed(3) : totalWeight} <span className="text-[9px] text-slate-400">KG</span></span>
                          </div>
                        </div>

                        <button
                          onClick={() => handleToggleSuggestionExpand(dieId)}
                          className="flex items-center gap-1.5 px-3.5 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 font-black text-[10px] uppercase tracking-widest rounded transition-colors border border-slate-200 cursor-pointer"
                          title="Expand order list"
                        >
                          {isExpanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                          {isExpanded ? "Hide Details" : "View Details"}
                        </button>

                        <button
                          disabled={isSending}
                          onClick={() => handleSendSuggestionToProduction(group)}
                          className="flex items-center gap-2 px-5 py-2 bg-primary hover:bg-[#2c5ebc] disabled:opacity-50 text-white font-black text-[10px] uppercase tracking-widest rounded transition-colors shadow-sm cursor-pointer"
                        >
                          <Send size={13} />
                          {isSending ? "Sending..." : "Send to Production"}
                        </button>
                      </div>
                    </div>

                    {isExpanded && (
                      <div className="p-4 bg-white border-t border-slate-100 transition-all">
                        {detailsLoading && !detailsList ? (
                          <div className="py-8 text-center text-slate-400 font-bold text-xs">
                            Loading order details for Die #{dieId}...
                          </div>
                        ) : detailsList && detailsList.length > 0 ? (
                          <div className="overflow-x-auto">
                            <Table
                              columns={[
                                {
                                  key: "orderNo",
                                  label: "Order No",
                                  align: "left",
                                  render: (val, ord) => <span className="text-primary font-black">{ord.order_No || ord.orderNo || ord.sales_Order_No || ord.id || "-"}</span>
                                },
                                {
                                  key: "customer",
                                  label: "Customer",
                                  align: "left",
                                  render: (val, ord) => ord.customer_Name || ord.customerName || ord.customer || "-"
                                },
                                {
                                  key: "alloy",
                                  label: "Alloy",
                                  align: "left",
                                  render: (val, ord) => ord.alloy_Name || ord.alloyName || ord.alloy || "-"
                                },
                                {
                                  key: "cutLength",
                                  label: "Cut Length",
                                  align: "right",
                                  render: (val, ord) => ord.cut_Length || ord.cutLength || "-"
                                },
                                {
                                  key: "pcs",
                                  label: "Pcs",
                                  align: "right",
                                  render: (val, ord) => <span className="text-slate-900 font-black">{ord.qty || ord.pcs || ord.quantity || "-"}</span>
                                },
                                {
                                  key: "wt",
                                  label: "Weight",
                                  align: "right",
                                  render: (val, ord) => <span className="text-primary font-black">{ord.wt || "-"} Kg</span>
                                },
                                {
                                  key: "reqDelivery",
                                  label: "Req. Date",
                                  align: "center",
                                  render: (val, ord) => ord.reqDelivery ? formatDate(ord.reqDelivery) : "-"
                                },
                                {
                                  key: "dispatchDays",
                                  label: "Dispatch Days",
                                  align: "center",
                                  render: (val, ord) => <span className="text-primary font-black">{ord.dispatchDays || "-"}</span>
                                },
                              ]}
                              data={detailsList}
                              showActions={false}
                              tableClassName="text-[11px] font-bold"
                            />
                          </div>
                        ) : (
                          <div className="py-6 text-center text-slate-400 font-medium text-xs">
                            No specific order details found for this die suggestion.
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="py-20 text-center bg-white rounded-xl border border-slate-200 border-dashed p-8">
                <div className="text-4xl mb-4">📦</div>
                <h4 className="text-[13px] font-black text-slate-700 uppercase tracking-widest">No Batch Suggestions Active</h4>
                <p className="text-[11px] text-slate-400 mt-1 font-medium">Currently there are no automated batch recommendations generated for pending sales orders.</p>
              </div>
            )}
            </div>
          )}

          <div className="px-8 py-4 bg-white border-t border-slate-200 flex justify-end items-center gap-4">
            <button
              onClick={() => setIsAutoBatchOpen(false)}
              className="px-8 py-2 border border-slate-300 text-slate-600 font-black text-[10px] uppercase tracking-widest hover:bg-slate-50 transition-all rounded"
            >
              Close
            </button>
          </div>
        </div>
      </Model>

      <TourGuide
        isOpen={isTourOpen}
        onClose={() => setIsTourOpen(false)}
        steps={OrderPlanView_OrderPlanViewTourSteps}
        onComplete={handleTourComplete}
      />
    </div>
  );
};

export default OrderPlanView;
